import React, { useContext, useState } from 'react';
import { GlobalState } from '../GlobalState';
import { Link } from 'react-router-dom';


const Vamosaprobar = () => {
    const state = useContext(GlobalState)
    const [products, setProducts] = state.productsAPI.products


    return (
        <div className='pruebas_apps'>

            {/*{
                products.map((produt) => (
                    <div>
                        <Link to={`/pruebas/${produt._id}`} >{produt.nombre}</Link>
                    </div>
                ))
            }*/}

        </div>
    );
}

export default Vamosaprobar;